<script setup>
import { useStore } from 'vuex';
import {useRouter} from 'vue-router';

const router = useRouter();
const store = useStore();

function close() {
  store.commit('hide');
  router.push('/');
}
function back() {
  router.push('/estimate');
}
</script>

<template>
  <header>
    <div class="d-flex align-items-center justify-content-end">
      <div @click="back()" class="d-flex align-items-center justify-content-start ml-2" v-if="router.currentRoute.value.path.includes('payment')">
        <svg aria-label="go back" role="button" width="23px" height="33px" viewBox="0 0 23 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Path 2</title>
    <g id="Custom-Springs-landing-page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-46, -35)" id="header" stroke="#44961C" stroke-width="3">
            <g transform="translate(-1.5, 17)">
                <polyline id="Path-2" transform="translate(59.5, 39.2716) rotate(-270) translate(-59.5, -39.2716)" points="39.5 30 60.802911 48.5431663 79.5 30"></polyline>
            </g>
        </g>
    </g>
</svg>
      </div>
      
      <div style="display:flex;align-items:center;justify-content:space-between;width:100%">
        <div style="height:100%;width:100%;">
          <div style="display:flex;align-items:center;justify-content:center;margin-left:15px"><a href="/" ><div class="logo" id="logo"></div></a></div>
        </div>

        <div @click="close()">
          <svg aria-label="close tool" role="button" width="37px" height="37px" class="close-modal" viewBox="0 0 37 37"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="padding-right:15px;cursor:pointer">
              <title>Group</title>
              <g id="Custom-Spring-form-V2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="custom-spring-form-1520" transform="translate(-1434, -37)" fill="#1C5296">
                      <g id="header-NEW" transform="translate(-1, 0)">
                          <g id="Group" transform="translate(1435.1152, 37.1152)">
                              <rect id="Rectangle" transform="translate(18.3848, 18.3848) rotate(-45) translate(-18.3848, -18.3848)" x="-6.11522369" y="16.8847763" width="49" height="3" rx="1.5"></rect>
                              <rect id="Rectangle" transform="translate(18.3848, 18.3848) rotate(-315) translate(-18.3848, -18.3848)" x="-6.11522369" y="16.8847763" width="49" height="3" rx="1.5"></rect>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
        </div>
      </div>
    </div>
  </header>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

header {
  border-bottom: #D8D8D8 1px solid;
}
.logo {
  background-image: url('https://springsfast.com/wp-content/uploads/2024/01/A-logo.png');
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  height: 75px;
  width:200px;
}
</style>
